export default __webpack_public_path__ + "static/media/9445@3x.aa3e8bc8.png";